import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  standalone: true,
  selector: 'lx-image',
  templateUrl: './image.component.html',
  imports: [NgOptimizedImage],
})
export class ImageComponent implements OnChanges {
  @Input() image = '';
  @Input() fallbackImage = '';
  @Input() width = 0;
  @Input() height = 0;
  @Input() alt = '';

  @Output() loadedImage = new EventEmitter<void>();

  imageSrc = '';

  ngOnChanges({ image, fallbackImage }: SimpleChanges): void {
    this.imageSrc = image?.currentValue || fallbackImage?.currentValue;
  }

  takeFallbackImage() {
    this.imageSrc = this.fallbackImage;
  }

  onLoadedImage() {
    this.loadedImage.emit();
  }
}
